import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrianglesDotsHorizontalExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1759_8363)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.75 2.25L3.75001 3L8.25 3V2.25L6.00001 0L3.75 2.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.25 9.75L8.24999 9L3.75 9V9.75L5.99999 12L8.25 9.75Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.75 5.25H11.25V6.75H9.75V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.25 5.25H6.75V6.75H8.25V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.75 5.25H5.25V6.75H3.75V5.25Z",
				fill: "black",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.25 5.25H0.75V6.75H2.25V5.25Z",
				fill: "black",
				fillOpacity: .6
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1759_8363",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgTrianglesDotsHorizontalExpand;
